// extracted by mini-css-extract-plugin
export default {"arrow":"PopUp_arrow__Su+cK","wrapper":"PopUp_wrapper__CpN9s","selectedImage":"PopUp_selectedImage__xiau5"};